import { Box, CloseButton, Group, Image } from '@mantine/core';
import { useEffect } from 'react';

export function FullSizeImage({ src, closeModals }) {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        closeModals();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [closeModals]);

  return (
    <>
      <Group justify="right" pos="fixed" w="100%" style={{ top: 0, left: 0, zIndex: 1 }} p="md">
        <CloseButton size="lg" onClick={closeModals} />
      </Group>

      <Box
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          border: 0,
        }}
      >
        <Image src={src} w="100%" h="100%" style={{ objectFit: 'contain' }} />
      </Box>
    </>
  );
}
